export default [
    {
        path: '/margin',
        component: () => import('@/views/Margin'),
        props: true,
    },
    {
        path: '/margin/:id',
        component: () => import('@/views/Margin/Show'),
        props: true,
    },
    {
        path: '/margin/:id/edit',
        component: () => import('@/views/Margin/Edit'),
        props: true,
    },
    {
        path: '/margin/:id/product',
        component: () => import('@/views/Margin/Product.vue'),
        props: true,
    },
];
